<template>
  <div>
    <b-overlay :show="loading" rounded="sm" :style="loading ? 'height:800px;overflow:hidden;' : ''">
      <PageValidate ref="ProductDetails" :MediaListRef="MediaListRef">
        <template v-slot:PageBody>

          <div class="CenterCard">
            <BasicPageTop :Name="$t('lbl_EMPBE_ProductInfo_Memu_ProductDetails')">
              <template v-slot:Body>
                <div class="BasicTop-Card" v-html="$t('lbl_EMPBE_ProductInfo_ProductDetails_Blue_p')">
                </div>
              </template>
            </BasicPageTop>
            <div>

              <div class="row">
                <div class="col-12">
                  <customtextarea :title="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsEn')" rows="5" ControlId="descE"
                    :placeholder="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsEn_PlaceOther')" v-model="form.formData.descE" max="1000"
                    :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsEn') + $t('lbl_IsRequire')" >
                  </customtextarea>
                  <ProductFieldApprovalResults usage-type="DescE" />
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <customtextarea :title="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsCn')" rows="5" ControlId="descT"
                    :placeholder="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsCn_PlaceOther')"
                    v-model="form.formData.descT" max="500"
                    :mandatory="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductDetailsCn') + $t('lbl_IsRequire')" >
                  </customtextarea>
                  <ProductFieldApprovalResults usage-type="DescS,DescT" />
                </div>
              </div>

              <div class="row" v-if="AplusABCBooth">
                <div class="col-12 mb-1 Input_Label">
                  <div class="Input_Label_Left">
                    {{$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductCatalog')}}
                  </div>
                </div>
                <div class="col-12 mb-2 LeadTime" v-html="GetCatalogMsg">
                  </div>
                <div class="col-12">
                  <multiselection id="catalogueList" v-model="form.catalogueList" label="name" track-by="code"
                    :options="SelectOptions.ProductCatalogOptions" :multiple="true" :taggable="true"
                    :title="$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductCatalog_PlaceOther')">
                  </multiselection>
                </div>
              </div>
              <div class="row" v-if="AplusABCBasicBooth">
                <div class="col-12 mb-2 Input_Label">
                  <div class="Input_Label_Left">
                    {{$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductCertification',{MaxQuota:GetCertificationNums})}}
                  </div>
                </div>
                <div class="col-12" id="certificationList">
                  <CertificationList
                    :nums="GetCertificationNums"
                    v-model="form.certificationList"
                    :CertificationTypeOptions="SelectOptions.ProductCertifiationTypeOptions"
                    :supplierId="supplierId"
                    :ProductId="reactiveProductId"
                    ref="ProdCertificationList"
                    @removeCertImage="removeCertImage"
                  />
                </div>
              </div>
            </div>
          </div>

        </template>
      </PageValidate>
    </b-overlay>
  </div>

</template>

<script>
import { productService } from "@/_services/product.service";
import { LogService } from "../../../_services/log.Service";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import BasicPageTop from "./BasicPageTop.vue"
import CertificationList from "./CertificationList.vue";
import { AlertDialog } from "@/_helpers/AlertDialog";
import ProductFieldApprovalResults from "../ProductFieldApprovalResults.vue";
export default {
  components: {
    BasicPageTop, CertificationList, ProductFieldApprovalResults
  },
  props: ["supplierId", "ProductId", "SelectOptions", "permissionData","PageLeaveType", "submitType"],
  mixins: [AlertDialog],
  data() {
    return {
      privateProductId: this.ProductId,
      loading: false,
      IsCreated: false,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      form:
      {
        formData: {
          empCompanyId: "",
          productId: "",
          descT: "",
          descE: "",
        },
        catalogueList: [],
        certificationList: []
      },
      disabledDates: {
      },
      removeCertCommands: [],
      MediaListRef: [],
    };
  },
  watch: {
    supplierId: {
      handler() {
        this.InitData();
      },
      deep: true,
    },
    form: {
      handler() {
        if (!this.IsCreated) {
          this.$store.state.dirty = true;
        }
      },
      deep: true,
    },
    ProductId: {
      handler(newVal) {
        this.privateProductId = newVal;
      },
    },
    "form.certificationList": {
      handler(newVal) {
        const newRef = [];
        for (let i = 0; i < newVal.length; i++) {
          newRef.push(`ProdCertificationList.certMediaUploader_${i}`);
        }

        this.MediaListRef = [...newRef];
      },
      deep: true,
    },
  },
  computed: {
    useFormalTables() {
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    user() {
      return this.$store.state.authentication.user;
    },
    GetCatalogMsg(){
      const linkText = this.$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductCatalog_Desc_ProductCatalog');
      return this.$t('lbl_EMPBE_ProductInfo_ProductDetails_ProductCatalog_Desc', {
        link: `<a  style="color: var(--primary-supplier-backend, #7366FF);cursor: pointer;"  id="dynamic-link">${linkText}</a>`
      });
    },
    GetCertificationNums(){
      if(this.permissionData)
      {
        switch(this.permissionData["Type"]){
            case "A+":
              return 10;
            case "A":
              return 5;
            case "B":
              return 4;
            case "C":
              return 2;
            case "Member":
              return 2;
        }
      }
      return 1;
    },
    AplusABCBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    AplusABCBasicBooth() {
      if (this.permissionData) {
        return ["A+","A", "B", "C","Member"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    reactiveProductId() {
      return this.privateProductId && this.privateProductId > 0 ? this.privateProductId : (this.$route.params.id || 0);
    },
  },
  mounted() {
    this.InitData();
    const linkElement = document.getElementById('dynamic-link');
    if (linkElement) {
      linkElement.addEventListener('click', this.GotoCatalog);
    }
  },
  beforeDestroy() {
    const linkElement = document.getElementById('dynamic-link');
    if (linkElement) {
      linkElement.removeEventListener('click', this.GotoCatalog);
    }
  },
  methods: {
    GotoCatalog(){
      var title ="";
      var text="";
      var ConfirmBtn ="";
      var Operate="";
      if(this.$store.state.dirty){
         if(this.PageLeaveType==1)
      {
        title=this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title');
        text=this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body');
        ConfirmBtn=this.$t('lbl_EMPBE_CompanyInfo_Submit');
        Operate="submit";
      }else if(this.PageLeaveType==2) 
      {
        title=this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title');
        text=this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body');
        ConfirmBtn=this.$t('lbl_EMPBE_CompanyInfo_Save');
        Operate="save";
      }
      this.showLeavePageAfterSave(
                  title,
                  text,
                  ConfirmBtn,
                ).then((result) => {
                if (result.isDenied) {
                  this.$router.push('/productInfoCenter/indexDetail/0');
                } else if (result.isConfirmed) {
                  this.$emit(Operate);
                }
              });
      }else{
         this.$router.push('/productInfoCenter/indexDetail/0');
      }
     
    },
    InitData() {
      this.GetData();
      this.resetFormVerify();
      setTimeout(() => {
        this.$store.state.dirty =false;
      }, 200);
    },
    GetData() {
      this.loading = true;
      this.IsCreated = true;
      this.resetFilePendingUpdate();
      productService.GetProductDetail({ companyId: this.supplierId, ProductId: this.reactiveProductId, useFormalTables: this.useFormalTables }).then(res => {
        if (res.isSuccessful) {
          this.form.formData = res.data.formData ?? { ...this.form.formData, productId: this.reactiveProductId };
          this.form.catalogueList = res.data.catalogueList;
          this.form.certificationList = res.data.certificationList?.sort((a, b) => {
            const oa = a.orderId ?? a.OrderId ?? a.OrderID ?? 0;
            const ob = b.orderId ?? b.OrderId ?? b.OrderID ?? 0;
            return oa - ob;
          }).map(c => {
            // Dapper 动态行序列化可能是 PascalCase（FileID/FileName），统一成前端字段
            const fileID = c.fileID ?? c.fileId ?? c.FileID ?? null;
            const fileName = c.fileName ?? c.FileName ?? null;
            return {
              ...c,
              rid: c.rid ?? c.RID ?? c.Rid ?? null,
              empCompanyId: c.empCompanyId ?? c.EmpCompanyId ?? null,
              certificationType: c.certificationType ?? c.CertificationType ?? '',
              certificationName: c.certificationName ?? c.CertificationName ?? '',
              orderId: c.orderId ?? c.OrderId ?? c.OrderID ?? 0,
              fileID,
              fileName,
              isPendingInsert: false,
              updateFileCommands: [],
              pendingFiles: [],
            };
          }) ?? [];
        }
        setTimeout(() => {
          this.IsCreated = false;
        }, 500);
        //this.loading = false;
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      })
    },
    //重置表单验证
    resetFormVerify() {
      this.$refs.ProductDetails.reset();
    },

    resetFilePendingUpdate() {
      this.form.certificationList = this.form.certificationList.map(c => {
        return {
          ...c,
          isPendingInsert: false,
          pendingFiles: [],
          updateFileCommands: [],
        }
      });

      this.removeCertCommands = [];
    },

    fileUploadHandle(isSubmit = true) {
      const pendingFiles = [];

      this.form.certificationList.reduce((acc, curr) => {
          return curr.pendingFiles && curr.pendingFiles.length > 0 ? [...acc, ...curr.pendingFiles] : acc;
      }, []).forEach(f => {
        pendingFiles.push({
          ...f,
        })
      });

      return this.$submitFormMessage.FileUploadHandleWithPopup({
        isSubmit,
        pendingFiles,
        commands: [],
        getFailedText: {
          "ExhibitCertification": this.$t("lbl_EMPBE_ProductInfo_ProductDetails_ProductCertificationImage"),
        },
        uploadFinishCallback: (failedFilesFields) => this.$emit("uploadFinish", failedFilesFields)
      });
    },
    //整理結果提交save
    async AfterSaveResult(isSubmit) {
      var data =
      {
        EmpCompanyId: this.supplierId,
        ProductId: this.reactiveProductId ?? 0,
        DescT: this.form.formData.descT,
        DescE: this.form.formData.descE,
        CataloguesList: this.form.catalogueList.map((item, index) => {
          return {
            Id: item,
            OrderId: index
          }
        }),
        CertificationsList: [],
        VaildError: [], //验证失败的filed
        validationErrorLog: "" //验证的errorlog
      };

      try {
        const uploadRes = await this.fileUploadHandle(isSubmit);

        data.CertificationsList = this.form.certificationList.map((d, i) => {
          const listComp = this.$refs.ProdCertificationList;
          const img = listComp?.certImageList?.[i]?.[0];
          const imgCdn = img?.cdnLink || img?.previewSrc || null;
          const imgId = img?.id ?? null;

          const data = {
            rid: d.rid != null && d.rid !== '' ? d.rid : null,
            empCompanyId: d.empCompanyId,
            ProductId: d.ProductId,
            orderId: i + 1,
            certificationType: d.certificationType,
            certificationName: d.certificationName,
            fileID: d.fileID || imgId || null,
            // Get JOIN 失败时 form 可能没 fileName，从 uploader 回填，避免保存时空 FileName 把图删掉
            fileName: d.fileName || imgCdn || null
          };

          if (d.pendingFiles && d.pendingFiles.length > 0) {
            const pendingFileId = d.pendingFiles[0].id;
            const isUploaded = uploadRes?.successfulList?.find((u) => u.id === pendingFileId);
            
            if (isUploaded) {
              data.fileID = data.fileID || data.orderId * -1; // "UPDATE" | "INSERT"
              data.fileName = isUploaded.uploadedOssUrl;
            }
          } else if (d.updateFileCommands.length > 0 && d.updateFileCommands.find(c => c.command === 'DELETE')) {
            data.fileID = null;
            data.fileName = null;
          }

          return data;
        });
      } catch (error) {
        data.validationErrorLog += error
      }

      return data;
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.supplierId,
        EmpProductId: this.reactiveProductId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "ProductDetails",
        Action: action,
      }, errorLogObj);
    },

    //保存
    async Save() {
      var data = await this.AfterSaveResult(false);

      //写日志
      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Save',
        FormType: 'ProductInfo_ProductDetails',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);
      
      return new Promise((resolve, reject) => {
        productService.SaveProductDetail(data).then(res => {
          if (res.isSuccessful) {
            this.privateProductId = res.data;
            this.InitData();
            resolve({ data: res.data, state: true }); //用以确定当前不管作为修改亦或者添加id 都作为data 返回
          } else {
            this.LogPageFormError({ res: res }, 'Save_SaveProductDetail');
            reject({
              message: this.$t("lbl_EMPBE_Save_Failed_HasErrorAndCode", { code: res.statusCode, msg: res.msg?.join(",") || "Error" })
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Save_SaveProductDetail');
          reject({
            message: this.$t("lbl_EMPBE_Save_Failed_HasError", { msg: err.message })
          });
        })
      });

    },
    //提交
    async Submit() {
      var data = await this.AfterSaveResult(true);

      const query = {
        FormId: this.reactiveProductId,
        Action: 'Before_Submit',
        FormType: 'ProductInfo_ProductDetails',
        ErrorLog: data.validationErrorLog
      };
      LogService.LogFormDataWithObj(query, data);

      return new Promise((resolve, reject) => {
        productService.SaveProductDetail(data).then(result => {
          if (result.isSuccessful) {
            this.privateProductId = result.data;
            const newProductId = !this.$route.params.id || this.$route.params.id == 0 ? result.data : 0; // For adding new product id when reject

            this.$refs.ProductDetails
            .validate(true)
            .then(async (res) => {
              //写日志
              data.VaildError = res.fIldData;
              
              if (res.valid) 
              {
                this.InitData();
                resolve({ data: result.data, isAllMandatoryFieldsFilled: true });
              }
              else
              {
                this.GetData();
                resolve({ data: result.data, isAllMandatoryFieldsFilled: false });
              }
            });
          }
          else
          {
            this.LogPageFormError({ result: result }, 'Submit_SaveProductDetail');
            reject({
              message: this.$t("lbl_EMPBE_Submit_Failed_HasErrorAndCode",{code:result.statusCode,msg:result.msg?.join(",") || "Error"})
            });
          }
        }).catch(err => {
          this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, 'Submit_SaveProductDetail');
          reject({
            message: this.$t("lbl_EMPBE_Submit_Failed_HasError",{ msg: err.message })
          });
        });
      });
    },

    removeCertImage(deleteCommand) {
      this.removeCertCommands.push(deleteCommand);
    },
  },
};
</script>
<style>
.templateImg {
  height: 150px;
  object-fit: cover;
  object-position: top;
}
.ProductCatalog_Desc{
  color: var(--primary-supplier-backend, #7366FF);
  font-feature-settings: 'liga' off, 'clig' off;
  /* Text/Paragraph 2 */
  /* font-family: Inter; */
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.00938rem;
}
</style>